class FiltersOrdinarioService {
   findProcesoGeneral(list, itemId) {
      return list.find((list) => list.ANIO === itemId);
   }

   findComite(list, itemId) {
      return list.find((list) => list.ID_ORGANIZACION === itemId);
   }

   findEntidad(list, itemId) {
      return list.find((list) => list.ID_ESTADO === itemId);
   }

   findSujetoObligado(list, itemId) {
      return list.find((list) => list.ID_SUJETO_OBLIGADO === itemId);
   }
}

export default new FiltersOrdinarioService();
